<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>
                    <div class="content">
                        <div class="myOrderCont">
                            <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" class="myOrderTableHead">
                                <el-table-column prop="order_name" label="课程名" width="295">
                                </el-table-column>
                                <el-table-column prop="order_id" label="订单号" width="190">
                                </el-table-column>
                                <el-table-column prop="year" label="支付时间" width="150">
                                </el-table-column>
                                <el-table-column prop="price" label="支付金额" width="140">
                                </el-table-column>
                                <el-table-column prop="pay_type" label="支付方式" width="105">
                                </el-table-column>

                                <el-table-column prop="pay_status, is_receipt, order_id" label="状态" width="147">
                                    <template slot-scope="scope">

                                        <span @click="goPay(scope.row)" v-if="scope.row.pay_status == 1" class="seeElectronicInvoice gotoPayBtn">
                                            继续支付
                                        </span>
                                        <span v-if="scope.row.pay_status == 1" class="seeElectronicInvoice escOrderBtn"
                                            @click="calcelOrder(scope.row.order_id)">取消订单</span>



                                        <span v-if="scope.row.pay_status == 3" class="seeElectronicInvoice gotoPayBtn">
                                            <router-link to="/pay?orderId=`${scope.row.order_id}`">重新支付</router-link>
                                        </span>
                                        <span v-if="scope.row.pay_status == 3" class="seeElectronicInvoice escOrderBtn"
                                            @click="calcelOrder(scope.row.order_id)">取消订单</span>

                                        <span v-if="scope.row.pay_status == 4" class="alreadyFinishStatus">订单已取消</span>

                                        
                                        <span v-if="scope.row.pay_status == 2 && scope.row.refund_status == 0 && scope.row.is_receipt == 0"
                                            class="seeElectronicInvoice blueGradient requestRefundBtn">
                                            <router-link :to="{name:'requestRefund',query:{orderId:scope.row.order_id}}">申请退款</router-link>
                                        </span>

                                        <!-- pay_status支付状态【 1 未支付 2 支付成功  3 支付失败  4 订单已取消  5 已退款】 -->
                                        <!-- refund_status  退款状态  0 无操作  1 退款审核中 2 退款中 3 退款成功 4 退款失败  -->
                                        <!-- 支付成功 -->
                                        <template  v-if="scope.row.pay_status == 2" >
                                            <!-- 退款不是无操作 则显示退款状态 -->
                                            <template v-if='scope.row.refund_status != 0'>
                                                <span v-if="scope.row.refund_status == 1" class="seeElectronicInvoice littleBlueGradient">退款审核中</span>
                                                <span v-if="scope.row.refund_status == 2" class="seeElectronicInvoice littleBlueGradient">退款中</span>
                                                <span v-if="scope.row.refund_status == 3" class="alreadyFinishStatus">已完成退款</span>
                                                <template v-if='scope.row.refund_status == 4 && scope.row.is_receipt != 4 && scope.row.is_receipt != 1 && scope.row.is_receipt != 2'>
                                                    <span class="alreadyFinishStatus">退款失败</span>
                                                    <span class="seeElectronicInvoice">
                                                        <router-link :to="{name:'requestRefund',query:{orderId:scope.row.order_id}}">重新申请退款</router-link>
                                                    </span>
                                                    <span class="seeElectronicInvoice">
                                                        <router-link :to="{name:'requestInvoice',query:{type:'requestInvoice',orderId:scope.row.order_id}}">申请电子发票</router-link>
                                                    </span>
                                                </template>
                                            </template>

                                            <!-- 发票不是无操作 则显示发票状态 -->
                                            <template>
                                                <span v-if='scope.row.is_receipt == 0 && scope.row.refund_status == 0' class="seeElectronicInvoice">
                                                    <router-link :to="{name:'requestInvoice',query:{type:'requestInvoice',orderId:scope.row.order_id}}">申请电子发票</router-link>
                                                </span>
                                                <span v-if="scope.row.is_receipt == 1" class="alreadyFinishStatus">开票审核中</span>
                                                <span v-if="scope.row.is_receipt == 2" class="alreadyFinishStatus">
                                                    <!-- <router-link to="/requestInvoice?type=seeInvoice">查看电子发票</router-link> -->
                                                    开票中
                                                </span>
                                                <span v-if="scope.row.is_receipt == 3" class="alreadyFinishStatus">开票成功</span>
                                                <span v-if="scope.row.is_receipt == 4" class="alreadyFinishStatus">开票失败</span>
                                                <span v-if='scope.row.is_receipt == 4' class="seeElectronicInvoice">
                                                    <router-link :to="{name:'requestInvoice',query:{type:'requestInvoice',orderId:scope.row.order_id}}">重新申请开票</router-link>
                                                </span>
                                            </template>

                                        </template>

                                        <span v-if="scope.row.pay_status == 5" class="alreadyFinishStatus">已退款</span>


                                    </template>
                                </el-table-column>

                            </el-table>
                        </div>
                        <common-confirm @sure='sure'></common-confirm>
                    </div>
                </section>
            </el-main>
        </el-container>
    </el-container>

</template>
<script>
import commonheader from "../common/commonHeader.vue"; //头部组件
import leftMenu from "../common/leftMenu.vue"; //头部组件
import exit from "../common/exit.vue"; //头部组件
import commonConfirm from "../common/confirm.vue";


export default {
    name: 'studentsNote',
    components: {
        commonheader,
        leftMenu,
        exit,
        commonConfirm
    },
    data () {
        return {
            loading:true,
            orderId:'',
            tableData: [
                // {
                //     courseName: '湖南省药师协会会费',
                //     orderNumber: '202005168638292402',
                //     payTime: '2020.12.12  14:19',
                //     payMoney: '30.00',
                //     payMethod: '办公室转学员',
                //     operateId: '1',
                //     operate: {
                //         'electronicInvoiceleStatus': 1,  // 1申请电子发票 2已申请电子发票 3查看电子发票
                //         'refundStatus': 1 // 1申请退款 2退款中 3已完成退款s
                //     }
                // }, 
                //  {
                //     courseName: '湖南省药师协会会费',
                //     orderNumber: '202005168638292402',
                //     payTime: '2020.12.12  14:19',
                //     payMoney: '30.00',
                //     payMethod: '办公室转学员',
                //     operate: {
                //         'electronicInvoiceleStatus': 2,  // 1申请电子发票 2已申请电子发票 3查看电子发票
                //         'refundStatus': 2 // 1申请退款 2退款中 3已完成退款s
                //     }
                // }, 
                // {
                //     courseName: '湖南省药师协会会费',
                //     orderNumber: '202005168638292402',
                //     payTime: '2020.12.12  14:19',
                //     payMoney: '30.00',
                //     payMethod: '办公室转学员',
                //     operate: {
                //         'electronicInvoiceleStatus': 3,  // 1申请电子发票 2已申请电子发票 3查看电子发票
                //         'refundStatus': 3 // 1申请退款 2退款中 3已完成退款s
                //     }
                // },                 
            ],
        }
    },
    mounted: function () {
        document.getElementsByTagName("html")[0].className = "my-page";
        this.initMyOrder();
    },
    methods: {
        /**
         * 获取订单列表接口
         */
        initMyOrder () {
            this.$store.dispatch('myOrders', {})
                .then((res) => {
                    if (res.code == 200) {
                        this.tableData = res.data
                    }
                    this.loading = false;
                }).catch(error => {
                    console.error('错误信息：', error)
                    this.loading = false;
                })
        },
        /**
         * 取消订单接口
         */
        calcelOrder (orderId) {
            this.orderId = orderId;
            let target = {
                public_model_show: true,
                public_model_text: '您确定取消订单吗？',
                public_model_param: {}
            }
            this.$store.commit("show_public_model", target);
        },
        /**
         * 弹窗确定
         */
        sure(){
            let calcelOrderParams = {
                order_id: this.orderId
            }
            this.$store.dispatch('cancelOrder', calcelOrderParams)
                .then((res) => {
                    if (res.code == 200) {
                        this.$message('取消成功');
                        this.initMyOrder();
                    }
                }).catch(error => {
                    console.error('错误信息：', error)
                })
        },
        /**
         * 去支付
         */
        goPay(params){
            // console.log(params)
            // {"year":2019,"cids":"1,2,3,4,5,7,46","type":1,"price":"0.07"}
            let obj = {
                year:params.year,
                price:params.price,
                type:params.education_type,
                cids:'',
                order_id:params.order_id,
            };
            
            localStorage.setItem('netClassPayData',JSON.stringify(obj))
            this.$router.push('/pay')
        }
    },
}
</script>

<style lang="stylus" scoped>
@media (min-width: 1399px)
    .el-container-master
        width 1400px
        margin auto
.el-aside
    background #fff
.el-main
    padding 0
    background #fff
.content
    padding 47px 57px 20px 86px
    flex 1
    border-top 10px solid #F8F8F8
    border-left 10px solid #F8F8F8
    .title
        margin 25px 0 19px
        font-size 20px
        color #0173FF
        border-left 2px solid #0173FF
        padding-left 10px
    p
        font-size 16px
        color #333
        line-height 30px
</style>
<style lang="stylus">
.myOrderTableHead
    th
        text-align center!important
    td
        text-align center!important
.seeElectronicInvoice
    width 96px
    heihgt 26px
    line-height 26px
    text-align center
    color #0173FF
    border 1px solid #0173FF
    border-radius 4px
    display block
    cursor pointer
    margin 10px auto
.seeElectronicInvoice a
    color #0173FF
.blueGradient
    background-image -webkit-linear-gradient(left, #4BB7FC, rgb(31, 132, 255))
    background-image -o-linear-gradient(left, #4BB7FC, rgb(31, 132, 255))
    background-image -ms-linear-gradient(left, #4BB7FC, rgb(31, 132, 255))
    background-image linear-gradient(left, #4BB7FC, rgb(31, 132, 255))
    color #fff
    border none
    letter-spacing 2px
.littleBlueGradient
    background-image -webkit-linear-gradient(left, #b1dcfe, #9dcaff)
    background-image -o-linear-gradient(left, #b1dcfe, #9dcaff)
    background-image -ms-linear-gradient(left, #b1dcfe, #9dcaff)
    background-image linear-gradient(left, #b1dcfe, #9dcaff)
    color #fff
    border none
    letter-spacing 2px
.alreadyFinishStatus
    color rgba(153, 153, 153, 1)
    font-size 22
    display block
    text-align center
.requestRefundBtn a
    color #fff
</style>


// WEBPACK FOOTER //
// src/components/my/order.vue